import { PropsWithChildren, useEffect } from 'react';
import { useKeyPress } from '@pairy/react-hooks';

import useUpdateViewerPageState from '../../../../hooks/useUpdateViewerPageState';

interface Props {
  totalPage: number;
  isNextPageButtonDisabled?: boolean;
  updatePrevThumbnails?: (page: number) => void;
  updateNextThumbnails?: (page: number) => void;
}

const KeyPressLayer = ({
  children,
  totalPage,
  isNextPageButtonDisabled,
  updateNextThumbnails,
  updatePrevThumbnails,
}: PropsWithChildren<Props>) => {
  const { currentPage, updateCurrentPage } = useUpdateViewerPageState();

  const isPressPrevPage = useKeyPress('ArrowLeft, PageUp, ArrowUp');
  const isPressNextPage = useKeyPress('ArrowRight, ArrowDown, PageDown');

  const isFirstPage = currentPage === 1;
  const isLastPage = totalPage === currentPage;

  useEffect(() => {
    if (isPressPrevPage && !isFirstPage) {
      updateCurrentPage(currentPage - 1);
      updatePrevThumbnails?.(currentPage - 1);
    }
    if (isPressNextPage && !isLastPage && !isNextPageButtonDisabled) {
      updateCurrentPage(currentPage + 1);
      updateNextThumbnails?.(currentPage + 1);
    }
  }, [isPressNextPage, isPressPrevPage]);

  return <>{children}</>;
};

export default KeyPressLayer;
